import React from 'react';
import { useShieldPRDTelemetryForBrowser } from 'App/ShieldPRD/useShieldPRDTelemetryForBrowser';

export const ShieldPRDForBrowser: React.FC = () => {
	useShieldPRDTelemetryForBrowser();
	return null;
};
